import { render, staticRenderFns } from "./MaterialNameAndCasForm.vue?vue&type=template&id=4ffd6600&scoped=true"
import script from "./MaterialNameAndCasForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaterialNameAndCasForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffd6600",
  null
  
)

export default component.exports